import { render } from "./NeighborhoodAdd.vue?vue&type=template&id=82e32702"
import script from "./NeighborhoodAdd.vue?vue&type=script&lang=js"
export * from "./NeighborhoodAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__